var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAddPeriodic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_add_Periodic@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDFE2-UI_Recomm_PushRecomm_PeriodicClone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_add_Periodic",
    transform: "translate(-17, -5)",
    fill: "#0A186E"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17, 5)",
    id: "ic_edit"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5985, 2.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Approve",
    transform: "translate(0.0682, -0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-calendar/Outlined",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33333333,0.666666667 C4.33333333,0.298476823 4.03485641,2.22044605e-16 3.66666667,2.22044605e-16 C3.29847692,2.22044605e-16 3,0.298476823 3,0.666666667 L3,1 L2.33333333,1 C1.04466921,1 6.66133815e-16,2.04466845 6.66133815e-16,3.33333308 L6.66133815e-16,11 C6.66133815e-16,12.2886648 1.04466934,13.3333333 2.33333359,13.3333333 L10.3333333,13.3333333 C11.6219971,13.3333333 12.6666667,12.2886648 12.6666667,11 L12.6666667,3.33333333 C12.6666667,2.04466883 11.6219971,1 10.3333333,1 L9.66666667,1 L9.66666667,0.666666667 C9.66666667,0.298476823 9.36818949,2.22044605e-16 9,2.22044605e-16 C8.63181051,2.22044605e-16 8.33333333,0.298476823 8.33333333,0.666666667 L8.33333333,1 L4.33333333,1 L4.33333333,0.666666667 Z M11.3333333,4.05999349 L11.3333333,3.33333333 C11.3333333,2.78104858 10.8856181,2.33333333 10.3333333,2.33333333 L9.66666667,2.33333333 L9.66666667,2.66666667 C9.66666667,3.03485641 9.36818949,3.33333333 9,3.33333333 C8.63181051,3.33333333 8.33333333,3.03485641 8.33333333,2.66666667 L8.33333333,2.33333333 L4.33333333,2.33333333 L4.33333333,2.66666667 C4.33333333,3.03485641 4.03485641,3.33333333 3.66666667,3.33333333 C3.29847692,3.33333333 3,3.03485641 3,2.66666667 L3,2.33333333 L2.33333333,2.33333333 C1.78104846,2.33333333 1.33333333,2.78104858 1.33333333,3.33333308 L1.33333333,4.05999349 L11.3333333,4.05999349 Z M1.33333333,5.39332682 L11.3333333,5.39332682 L11.3333333,11 C11.3333333,11.5522847 10.8856181,12 10.3333333,12 L2.33333359,12 C1.78104871,12 1.33333333,11.5522847 1.33333333,11 L1.33333333,5.39332682 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5327, 8.5718) rotate(45) translate(-6.5327, -8.5718)translate(4.3333, 6.3798)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.206675683,1.64203102 L4.10667568,1.64203102 C4.4104323,1.64203102 4.65667568,1.88827441 4.65667568,2.19203102 C4.65667568,2.49578763 4.4104323,2.74203102 4.10667568,2.74203102 L0.206675683,2.74203102 C-0.0970809298,2.74203102 -0.343324317,2.49578763 -0.343324317,2.19203102 C-0.343324317,1.88827441 -0.0970809298,1.64203102 0.206675683,1.64203102 Z",
    transform: "translate(2.1567, 2.192) rotate(45) translate(-2.1567, -2.192)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.206675683,1.64203102 L4.20667568,1.64203102 C4.5104323,1.64203102 4.75667568,1.88827441 4.75667568,2.19203102 C4.75667568,2.49578763 4.5104323,2.74203102 4.20667568,2.74203102 L0.206675683,2.74203102 C-0.0970809298,2.74203102 -0.343324317,2.49578763 -0.343324317,2.19203102 C-0.343324317,1.88827441 -0.0970809298,1.64203102 0.206675683,1.64203102 Z",
    transform: "translate(2.2067, 2.192) rotate(135) translate(-2.2067, -2.192)"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddPeriodic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_add_Periodic.02d5052023ab37570b320ebdd45eb979.svg";